import { useState, useCallback } from "react";
import { productService } from "../services/productService";

export const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState(""); // Kategori adını saklamak için
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProductsByCategory = useCallback(async (categoryId) => {
    console.log(
      "useProducts - fetchProductsByCategory çağrıldı, categoryId:",
      categoryId
    ); // Fonksiyon çağrıldı mı?
    if (!categoryId) {
      console.log("useProducts - categoryId yok, fetch işlemi durduruldu.");
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await productService.getProductsByCategory(categoryId);
      console.log("useProducts - Gelen API Yanıtı:", JSON.stringify(response));

      let productsData = [];
      let fetchedCategoryName = "Kategori";

      // Yanıt doğrudan dizi mi, yoksa {status, data} yapısında mı?
      if (Array.isArray(response)) {
        // Doğrudan dizi geldiyse
        console.log("useProducts - Yanıt doğrudan dizi, data alınıyor.");
        productsData = response;
        if (productsData.length > 0) {
          // Doğrudan dizi içinde category bilgisi var mı kontrol etmeliyiz.
          // API yanıtına göre bu bilgi her üründe tekrarlanıyor.
          fetchedCategoryName = productsData[0]?.category?.name || "Kategori";
        }
      } else if (
        response &&
        response.status === 1 &&
        Array.isArray(response.data)
      ) {
        // {status, data} geldiyse
        console.log(
          "useProducts - Yanıt {status, data} yapısında, data alınıyor."
        );
        productsData = response.data;
        if (productsData.length > 0) {
          fetchedCategoryName = productsData[0]?.category?.name || "Kategori";
        }
      } else {
        console.warn("useProducts - Beklenmeyen ürün yanıtı yapısı:", response);
      }

      setProducts(productsData);
      setCategoryName(fetchedCategoryName);
      return productsData;
    } catch (err) {
      setError(err.message || "Ürünler getirilemedi");
      setCategoryName("Hata");
      setProducts([]);
      console.error("Ürün getirme hatası:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    products,
    categoryName,
    loading,
    error,
    fetchProductsByCategory,
  };
};

export default useProducts;
